import { track } from '@farmersdog/analytics';
import { eventNames } from './eventNames';

export function trackTriggerEvent(exitIntentShown: boolean) {
  track(eventNames.homepage_exit_intent_trigger, {
    exit_intent_shown_yesno: exitIntentShown,
  });
}
